import { CommissionStatus } from '@/types/referral';
import { useGetUserCommissions } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetReferralCommissionsProps = {
  pageNum?: number;
  pageSize?: number;
  status?: CommissionStatus;
  level?: number;
  startDate?: string;
  endDate?: string;
};

/* Hook */
export const useGetReferralCommissions = ({
  pageNum = 1,
  pageSize = 10,
  status,
  level,
  startDate,
  endDate,
}: UseGetReferralCommissionsProps = {}) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { data, isLoading, isError, error, refetch } = useGetUserCommissions({
    enabled: !!id,
    userId: id ?? 0,
  });

  // Filter and paginate on client side if needed
  // TODO: Update when SDK supports server-side filtering
  const filteredRecords = (data?.records || []).filter((commission: any) => {
    if (status && commission.status !== status) return false;
    if (level && commission.level !== level) return false;
    if (startDate && new Date(commission.createdAt) < new Date(startDate))
      return false;
    if (endDate && new Date(commission.createdAt) > new Date(endDate))
      return false;
    return true;
  });

  // Client-side pagination
  const startIndex = (pageNum - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedRecords = filteredRecords.slice(startIndex, endIndex);

  /* Return */
  return {
    isLoading,
    isError,
    error,
    refetch,
    total: filteredRecords.length,
    records: paginatedRecords,
  };
};
